import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CustomRadioButton from "../common/CustomRadioButton";
import ActionButton from "../common/Action Buttons/ActionButton";
import ActionButton2 from "../common/Action Buttons/ActionButton2";
import Dialog from "@material-ui/core/Dialog";
import {uploadDocument} from "../../api/network/documentService";
import {roles} from "../../utils/auth";
import SignatureComponent from "../common/SignatureComponent";
import CustomFileInput from '../common/CustomFileInput';


const DialogAction = styled.div`
    width: 100%;
    height: fit-content;
    
    margin: 20px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    
     > * {
      margin-right: 24px;
    }
`;

const DialogSubHead = styled.span`
    color: var(--color-black);
    margin-bottom: 44px;
`;

const DialogForm = styled.span`
    color: var(--color-black);
    margin-bottom: 44px;
`;

const CustomStyledInput = styled.input`
    color: transparent; 
    outline: 0;
    height: 33px;
    width: var(--government-id-width);

    > div {
      width: fit-content;
    }
    &::-webkit-file-upload-button {
      visibility: hidden;
    }
    &::before {
      width: calc(100% - 0.125rem);
      text-align: center;
      content: 'Upload Invoice';
      color: var(--accent-text);
      display: inline-block;
      border: 1px solid var(--accent);
      border-radius: var(--space-xs);
      padding: var(--space-s) 0;
      outline: none;
      white-space: nowrap;
      -webkit-user-select: none;
      cursor: pointer;
      font-weight: 500;
      font-size: var(--font-xs);
      transition: 0.2s background-color ease-in;
    }
    &:hover::before {
      background-color: var(--gray-secondary);
    }
    &:active {
      outline: 0;
      &::before {
      }
    }
    &:disabled::before {
      background-color: rgba(118,118,117,0.28);
    }
`;

/**
 * TODO consider use Container Component pattern to create a more reusable dialog component.
 * @param showDialog
 * @param id
 * @param companyName
 * @param setInvoiceDocument
 * @param onSubmitClick
 * @param onCloseClick
 * @param onDialogClose
 * @param role
 * @param setSignatureRef
 * @returns {*}
 * @constructor
 */
const CustomerContractDeliveryDialog = ({showDialog, id, companyName, setInvoiceDocument, onSubmitClick, onCloseClick, onDialogClose, role, setSignatureRef, contract}) => {

    const [radioOption, setRadioOption] = useState();
    const [canSubmitSignature, setCanSubmitSignature] = useState(false);
    const [isFile, setIsFile] = useState(false);

    const handleOnRadioChange = (e) => {
        let value = e.target.value;
        setRadioOption(value);
    };

    const onFileChange = (e) => {
        if (e) e.preventDefault();
        let file = e.target.files[0];
        if (file) setIsFile(true);
        setInvoiceDocument(file);
    };
    const isCustomerRep = role === roles.CUSTOMER_REP;

    return (
        <Dialog
            open={showDialog}
            keepMounted
            onClose={onDialogClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">
                {`Contract ${id} - Delivery Alert`}
                <hr style={{
                    border: ".5px solid var(--color-black)",
                    width: "100%",
                }}/>
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {
                        isCustomerRep
                            ? <DialogSubHead>
                                {`Complete delivery process by signing the accompanying delivery slip.`}
                            </DialogSubHead>
                            : <DialogSubHead>
                                {`Alert ${companyName} representatives to expect delivery of devices within the next 48 hours for contract `}
                                {<span style={{color: "var(--color-blue-600)"}}>{id}</span>}.
                            </DialogSubHead>
                    }
                </DialogContentText>

                <RadioGroup
                    row
                    aria-label="position"
                    name="position"
                    value={radioOption}
                    onChange={handleOnRadioChange}
                    >
                        <DialogForm>


                            {
                                contract && !contract.deliverySlipDocumentId ?
                                <FormControlLabel
                                    value={'physical'}
                                    label={isCustomerRep
                                        ? "Printed delivery slip, signed and returned to courier"
                                        : "Include printed delivery slip with courier"
                                    }
                                    control={<CustomRadioButton color={"primary"}/>}
                                    labelPlacement="end"
                                />

                                : <FormControlLabel
                                    value={'digital'}
                                    control={<CustomRadioButton color={"primary"}/>}
                                    label={isCustomerRep
                                        ? "Sign delivery slip digitally in the space provided"
                                        : "Include digital delivery slip with an Alert (auto generated)"
                                    }
                                    labelPlacement="end"
                                />
                            }
                            {
                                isCustomerRep && radioOption === 'digital' &&
                                <SignatureComponent
                                    width={560}
                                    setRef={setSignatureRef}
                                    onSignatureBegin={() => setCanSubmitSignature(false)}
                                    onSignatureEnd={() => setCanSubmitSignature(true)}
                                />
                            }
                            </DialogForm>
                    </RadioGroup>
            </DialogContent>


            <DialogAction>
                <ActionButton
                    onClick={onSubmitClick}
                    disabled={!radioOption ? true : (isCustomerRep ? (!canSubmitSignature && radioOption === 'digital') : (!isFile && radioOption === 'digital'))}
                    color="primary">
                    Submit
                </ActionButton>
                {
                    !isCustomerRep && radioOption === 'digital' &&
                    <CustomStyledInput
                        disabled={!radioOption || (radioOption && radioOption === 'start')}
                        type="file"
                        accept={".xlsx, .xls, .doc, .docx, .ppt, .pptx, .pdf, app/msword, app/vnd.ms-excel, app/vnd.ms-powerpoint, text/plain, app/pdf, image/*"}
                        onChange={onFileChange}
                    />
                }
                <ActionButton2 onClick={onCloseClick} color="primary">
                    Cancel
                </ActionButton2>
            </DialogAction>
        </Dialog>
    );
};

CustomerContractDeliveryDialog.propTypes = {
    contract: PropTypes.object
};
CustomerContractDeliveryDialog.defaultProps = {
    contract: {}
};

export default CustomerContractDeliveryDialog;
